import React, { useContext } from 'react';
import i18next from 'i18next';

import { setASSubpage } from '../../../../../utils/SspProvider/dispatchFunctions';
import { ASSubpageEnum } from '../../../../../enums';
import SspProviderContext from '../../../../../utils/SspProvider/context';
import SubpageWhite from '../../SubpageWhite';
import Teaserbox from '../../../../AutostadtTabComponents/Tiles/Teaserbox';
import { SET_DETAILS_NODE } from '../../../../../utils/SspProvider/store';
import SliderTile from '../../../../AutostadtTabComponents/Tiles/SliderTile';
import { DataNode, SliderTiles } from '../../../../../utils/PickUpTypes';

interface DiscoveryProps {
    title: string;
    imageSrc: string;
    imageCredits: string;
    subline: string;
    array: DataNode[];
    sliderArray?: SliderTiles[];
}
export default function Discovery({ title, imageSrc, imageCredits, subline, array, sliderArray }: DiscoveryProps) {
    const store = useContext(SspProviderContext);

    return (
        <SubpageWhite title={title} imageSrc={imageSrc} imageCredits={imageCredits} subline={subline}>
            <>
                {array.map(item => {
                    return (
                        <div key={item.titel} className='teaserbox-wrapper'>
                            <Teaserbox
                                size={'large'}
                                key={item.titel}
                                headline={item.titel}
                                text={item.teaser}
                                asset={item.bild_url}
                                onClick={() => {
                                    store.dispatch({ type: SET_DETAILS_NODE, value: item });
                                    setASSubpage(store, {
                                        asEnum: ASSubpageEnum.Details,
                                    });
                                }}
                            />
                        </div>
                    );
                })}
                {sliderArray && <SliderTile id='slider' headline={i18next.t('MoreAttractions')} tiles={sliderArray} />}
            </>
        </SubpageWhite>
    );
}
